// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/media_cms.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Upload } from "./file_pb";
import { file_api_proto_v1_file } from "./file_pb";
import type { FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/media_cms.proto.
 */
export const file_api_proto_v1_media_cms: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_file, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * 記事一覧の 1 件（サマリ）
 *
 * @generated from message api_proto.v1.MediaArticleSummary
 */
export type MediaArticleSummary = Message<"api_proto.v1.MediaArticleSummary"> & {
  /**
   * ULID (Crockford base32、26 文字)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * 公開 revision のタイトル（未公開なら draft のタイトル）
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * NULL = 未公開
   *
   * @generated from field: google.protobuf.Timestamp published_at = 4;
   */
  publishedAt?: Timestamp;

  /**
   * @generated from field: bool has_draft = 5;
   */
  hasDraft: boolean;

  /**
   * @generated from field: bool is_published = 6;
   */
  isPublished: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * 公開内容の最終更新日時。公開操作時のみ更新される（下書き保存では動かない）。NULL = 未公開
   *
   * @generated from field: google.protobuf.Timestamp content_updated_at = 8;
   */
  contentUpdatedAt?: Timestamp;
};

/**
 * Describes the message api_proto.v1.MediaArticleSummary.
 * Use `create(MediaArticleSummarySchema)` to create a new message.
 */
export const MediaArticleSummarySchema: GenMessage<MediaArticleSummary> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 0);

/**
 * 記事 revision の内容
 *
 * @generated from message api_proto.v1.MediaRevision
 */
export type MediaRevision = Message<"api_proto.v1.MediaRevision"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string list_title = 3;
   */
  listTitle: string;

  /**
   * @generated from field: string excerpt_html = 4;
   */
  excerptHtml: string;

  /**
   * @generated from field: string cover_url = 5;
   */
  coverUrl: string;

  /**
   * 空文字 = カテゴリなし
   *
   * @generated from field: string category_slug = 6;
   */
  categorySlug: string;

  /**
   * @generated from field: repeated string tag_slugs = 7;
   */
  tagSlugs: string[];

  /**
   * @generated from field: string body_html = 8;
   */
  bodyHtml: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * admin | cli | import
   *
   * @generated from field: string source = 10;
   */
  source: string;

  /**
   * SEO: <title> の上書き（空文字 = title を使う）
   *
   * @generated from field: string meta_title = 11;
   */
  metaTitle: string;

  /**
   * SEO: meta description の上書き（空文字 = excerpt から生成）
   *
   * @generated from field: string meta_description = 12;
   */
  metaDescription: string;

  /**
   * SEO: OGP 画像 URL の上書き（空文字 = cover_url を使う）
   *
   * @generated from field: string og_image_url = 13;
   */
  ogImageUrl: string;

  /**
   * SEO: true なら noindex（検索エンジンにインデックスさせない）
   *
   * @generated from field: bool noindex = 14;
   */
  noindex: boolean;

  /**
   * カバー画像の alt テキスト
   *
   * @generated from field: string cover_alt = 15;
   */
  coverAlt: string;

  /**
   * 空文字 = 著者なし。authors.id (ULID)
   *
   * @generated from field: string author_id = 16;
   */
  authorId: string;
};

/**
 * Describes the message api_proto.v1.MediaRevision.
 * Use `create(MediaRevisionSchema)` to create a new message.
 */
export const MediaRevisionSchema: GenMessage<MediaRevision> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 1);

/**
 * 記事内容（保存・公開リクエスト共通）
 *
 * @generated from message api_proto.v1.MediaArticleContent
 */
export type MediaArticleContent = Message<"api_proto.v1.MediaArticleContent"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string list_title = 2;
   */
  listTitle: string;

  /**
   * @generated from field: string excerpt_html = 3;
   */
  excerptHtml: string;

  /**
   * @generated from field: string cover_url = 4;
   */
  coverUrl: string;

  /**
   * 空文字 = カテゴリなし
   *
   * @generated from field: string category_slug = 5;
   */
  categorySlug: string;

  /**
   * @generated from field: repeated string tag_slugs = 6;
   */
  tagSlugs: string[];

  /**
   * @generated from field: string body_html = 7;
   */
  bodyHtml: string;

  /**
   * SEO: <title> の上書き（空文字 = title を使う）
   *
   * @generated from field: string meta_title = 8;
   */
  metaTitle: string;

  /**
   * SEO: meta description の上書き（空文字 = excerpt から生成）
   *
   * @generated from field: string meta_description = 9;
   */
  metaDescription: string;

  /**
   * SEO: OGP 画像 URL の上書き（空文字 = cover_url を使う）
   *
   * @generated from field: string og_image_url = 10;
   */
  ogImageUrl: string;

  /**
   * SEO: true なら noindex
   *
   * @generated from field: bool noindex = 11;
   */
  noindex: boolean;

  /**
   * カバー画像の alt テキスト
   *
   * @generated from field: string cover_alt = 12;
   */
  coverAlt: string;

  /**
   * 空文字 = 著者なし。authors.id (ULID)
   *
   * @generated from field: string author_id = 13;
   */
  authorId: string;
};

/**
 * Describes the message api_proto.v1.MediaArticleContent.
 * Use `create(MediaArticleContentSchema)` to create a new message.
 */
export const MediaArticleContentSchema: GenMessage<MediaArticleContent> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 2);

/**
 * ListMediaArticles
 *
 * @generated from message api_proto.v1.ListMediaArticlesRequest
 */
export type ListMediaArticlesRequest = Message<"api_proto.v1.ListMediaArticlesRequest"> & {
  /**
   * 1 始まり
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * デフォルト 20
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message api_proto.v1.ListMediaArticlesRequest.
 * Use `create(ListMediaArticlesRequestSchema)` to create a new message.
 */
export const ListMediaArticlesRequestSchema: GenMessage<ListMediaArticlesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 3);

/**
 * @generated from message api_proto.v1.ListMediaArticlesResponse
 */
export type ListMediaArticlesResponse = Message<"api_proto.v1.ListMediaArticlesResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.MediaArticleSummary articles = 1;
   */
  articles: MediaArticleSummary[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message api_proto.v1.ListMediaArticlesResponse.
 * Use `create(ListMediaArticlesResponseSchema)` to create a new message.
 */
export const ListMediaArticlesResponseSchema: GenMessage<ListMediaArticlesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 4);

/**
 * GetMediaArticle
 *
 * @generated from message api_proto.v1.GetMediaArticleRequest
 */
export type GetMediaArticleRequest = Message<"api_proto.v1.GetMediaArticleRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api_proto.v1.GetMediaArticleRequest.
 * Use `create(GetMediaArticleRequestSchema)` to create a new message.
 */
export const GetMediaArticleRequestSchema: GenMessage<GetMediaArticleRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 5);

/**
 * @generated from message api_proto.v1.GetMediaArticleResponse
 */
export type GetMediaArticleResponse = Message<"api_proto.v1.GetMediaArticleResponse"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 3;
   */
  publishedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;

  /**
   * NULL = 未公開
   *
   * @generated from field: api_proto.v1.MediaRevision published_revision = 5;
   */
  publishedRevision?: MediaRevision;

  /**
   * NULL = 下書きなし
   *
   * @generated from field: api_proto.v1.MediaRevision draft_revision = 6;
   */
  draftRevision?: MediaRevision;

  /**
   * 公開内容の最終更新日時。公開操作時のみ更新される（下書き保存では動かない）。NULL = 未公開
   *
   * @generated from field: google.protobuf.Timestamp content_updated_at = 7;
   */
  contentUpdatedAt?: Timestamp;
};

/**
 * Describes the message api_proto.v1.GetMediaArticleResponse.
 * Use `create(GetMediaArticleResponseSchema)` to create a new message.
 */
export const GetMediaArticleResponseSchema: GenMessage<GetMediaArticleResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 6);

/**
 * SaveMediaArticleDraft
 *
 * @generated from message api_proto.v1.SaveMediaArticleDraftRequest
 */
export type SaveMediaArticleDraftRequest = Message<"api_proto.v1.SaveMediaArticleDraftRequest"> & {
  /**
   * slug 未存在なら articles 行を自動作成（id は ULID）
   *
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: api_proto.v1.MediaArticleContent content = 2;
   */
  content?: MediaArticleContent;
};

/**
 * Describes the message api_proto.v1.SaveMediaArticleDraftRequest.
 * Use `create(SaveMediaArticleDraftRequestSchema)` to create a new message.
 */
export const SaveMediaArticleDraftRequestSchema: GenMessage<SaveMediaArticleDraftRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 7);

/**
 * @generated from message api_proto.v1.SaveMediaArticleDraftResponse
 */
export type SaveMediaArticleDraftResponse = Message<"api_proto.v1.SaveMediaArticleDraftResponse"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 draft_revision_id = 2;
   */
  draftRevisionId: bigint;
};

/**
 * Describes the message api_proto.v1.SaveMediaArticleDraftResponse.
 * Use `create(SaveMediaArticleDraftResponseSchema)` to create a new message.
 */
export const SaveMediaArticleDraftResponseSchema: GenMessage<SaveMediaArticleDraftResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 8);

/**
 * PublishMediaArticle
 *
 * @generated from message api_proto.v1.PublishMediaArticleRequest
 */
export type PublishMediaArticleRequest = Message<"api_proto.v1.PublishMediaArticleRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * optional: nil ならば現在の draft revision を昇格（content に title が無い場合も昇格とみなす）
   *
   * @generated from field: api_proto.v1.MediaArticleContent content = 2;
   */
  content?: MediaArticleContent;
};

/**
 * Describes the message api_proto.v1.PublishMediaArticleRequest.
 * Use `create(PublishMediaArticleRequestSchema)` to create a new message.
 */
export const PublishMediaArticleRequestSchema: GenMessage<PublishMediaArticleRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 9);

/**
 * @generated from message api_proto.v1.PublishMediaArticleResponse
 */
export type PublishMediaArticleResponse = Message<"api_proto.v1.PublishMediaArticleResponse"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 published_revision_id = 2;
   */
  publishedRevisionId: bigint;
};

/**
 * Describes the message api_proto.v1.PublishMediaArticleResponse.
 * Use `create(PublishMediaArticleResponseSchema)` to create a new message.
 */
export const PublishMediaArticleResponseSchema: GenMessage<PublishMediaArticleResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 10);

/**
 * DeleteMediaArticle
 * 記事本体に加え、全リビジョン・プレビュートークン・タグ紐付け（article_tags）・
 * 掲載枠（featured_items）をカスケード削除するハード削除。
 * 公開ページの CDN キャッシュ（s-maxage=300）により、削除後最大約5分は
 * edge から旧ページが配信されうる（purge は行わない。unpublish/編集と同じ特性）。
 *
 * @generated from message api_proto.v1.DeleteMediaArticleRequest
 */
export type DeleteMediaArticleRequest = Message<"api_proto.v1.DeleteMediaArticleRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api_proto.v1.DeleteMediaArticleRequest.
 * Use `create(DeleteMediaArticleRequestSchema)` to create a new message.
 */
export const DeleteMediaArticleRequestSchema: GenMessage<DeleteMediaArticleRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 11);

/**
 * @generated from message api_proto.v1.DeleteMediaArticleResponse
 */
export type DeleteMediaArticleResponse = Message<"api_proto.v1.DeleteMediaArticleResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteMediaArticleResponse.
 * Use `create(DeleteMediaArticleResponseSchema)` to create a new message.
 */
export const DeleteMediaArticleResponseSchema: GenMessage<DeleteMediaArticleResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 12);

/**
 * CreateMediaPreviewToken
 *
 * @generated from message api_proto.v1.CreateMediaPreviewTokenRequest
 */
export type CreateMediaPreviewTokenRequest = Message<"api_proto.v1.CreateMediaPreviewTokenRequest"> & {
  /**
   * content_type = ARTICLE/UNSPECIFIED のとき必須
   *
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: api_proto.v1.MediaPreviewTarget target = 2;
   */
  target: MediaPreviewTarget;

  /**
   * @generated from field: api_proto.v1.MediaPreviewContentType content_type = 3;
   */
  contentType: MediaPreviewContentType;

  /**
   * content_type = ROOFER のとき必須（slug / target は無視）
   *
   * @generated from field: int64 roofer_id = 4;
   */
  rooferId: bigint;
};

/**
 * Describes the message api_proto.v1.CreateMediaPreviewTokenRequest.
 * Use `create(CreateMediaPreviewTokenRequestSchema)` to create a new message.
 */
export const CreateMediaPreviewTokenRequestSchema: GenMessage<CreateMediaPreviewTokenRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 13);

/**
 * @generated from message api_proto.v1.CreateMediaPreviewTokenResponse
 */
export type CreateMediaPreviewTokenResponse = Message<"api_proto.v1.CreateMediaPreviewTokenResponse"> & {
  /**
   * 64 文字 hex（32 バイト乱数）
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * {MEDIA_SITE_ORIGIN}/preview/{token}
   *
   * @generated from field: string preview_url = 2;
   */
  previewUrl: string;
};

/**
 * Describes the message api_proto.v1.CreateMediaPreviewTokenResponse.
 * Use `create(CreateMediaPreviewTokenResponseSchema)` to create a new message.
 */
export const CreateMediaPreviewTokenResponseSchema: GenMessage<CreateMediaPreviewTokenResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 14);

/**
 * カテゴリ・タグ共通の形状
 *
 * @generated from message api_proto.v1.MediaTaxonomy
 */
export type MediaTaxonomy = Message<"api_proto.v1.MediaTaxonomy"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * 表示順は管理しない（新規作成時にサーバー側で末尾へ自動採番）
   *
   * @generated from field: string description = 4;
   */
  description: string;
};

/**
 * Describes the message api_proto.v1.MediaTaxonomy.
 * Use `create(MediaTaxonomySchema)` to create a new message.
 */
export const MediaTaxonomySchema: GenMessage<MediaTaxonomy> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 15);

/**
 * ListMediaCategories
 *
 * @generated from message api_proto.v1.ListMediaCategoriesRequest
 */
export type ListMediaCategoriesRequest = Message<"api_proto.v1.ListMediaCategoriesRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListMediaCategoriesRequest.
 * Use `create(ListMediaCategoriesRequestSchema)` to create a new message.
 */
export const ListMediaCategoriesRequestSchema: GenMessage<ListMediaCategoriesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 16);

/**
 * @generated from message api_proto.v1.ListMediaCategoriesResponse
 */
export type ListMediaCategoriesResponse = Message<"api_proto.v1.ListMediaCategoriesResponse"> & {
  /**
   * 表示順（サイトのナビ順。編集不可）
   *
   * @generated from field: repeated api_proto.v1.MediaTaxonomy categories = 1;
   */
  categories: MediaTaxonomy[];
};

/**
 * Describes the message api_proto.v1.ListMediaCategoriesResponse.
 * Use `create(ListMediaCategoriesResponseSchema)` to create a new message.
 */
export const ListMediaCategoriesResponseSchema: GenMessage<ListMediaCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 17);

/**
 * UpsertMediaCategory（slug をキーに作成 / 更新）
 *
 * @generated from message api_proto.v1.UpsertMediaCategoryRequest
 */
export type UpsertMediaCategoryRequest = Message<"api_proto.v1.UpsertMediaCategoryRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message api_proto.v1.UpsertMediaCategoryRequest.
 * Use `create(UpsertMediaCategoryRequestSchema)` to create a new message.
 */
export const UpsertMediaCategoryRequestSchema: GenMessage<UpsertMediaCategoryRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 18);

/**
 * @generated from message api_proto.v1.UpsertMediaCategoryResponse
 */
export type UpsertMediaCategoryResponse = Message<"api_proto.v1.UpsertMediaCategoryResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaTaxonomy category = 1;
   */
  category?: MediaTaxonomy;
};

/**
 * Describes the message api_proto.v1.UpsertMediaCategoryResponse.
 * Use `create(UpsertMediaCategoryResponseSchema)` to create a new message.
 */
export const UpsertMediaCategoryResponseSchema: GenMessage<UpsertMediaCategoryResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 19);

/**
 * DeleteMediaCategory（記事 revision から参照されている場合は FailedPrecondition）
 *
 * @generated from message api_proto.v1.DeleteMediaCategoryRequest
 */
export type DeleteMediaCategoryRequest = Message<"api_proto.v1.DeleteMediaCategoryRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api_proto.v1.DeleteMediaCategoryRequest.
 * Use `create(DeleteMediaCategoryRequestSchema)` to create a new message.
 */
export const DeleteMediaCategoryRequestSchema: GenMessage<DeleteMediaCategoryRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 20);

/**
 * @generated from message api_proto.v1.DeleteMediaCategoryResponse
 */
export type DeleteMediaCategoryResponse = Message<"api_proto.v1.DeleteMediaCategoryResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteMediaCategoryResponse.
 * Use `create(DeleteMediaCategoryResponseSchema)` to create a new message.
 */
export const DeleteMediaCategoryResponseSchema: GenMessage<DeleteMediaCategoryResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 21);

/**
 * ListMediaTags
 *
 * @generated from message api_proto.v1.ListMediaTagsRequest
 */
export type ListMediaTagsRequest = Message<"api_proto.v1.ListMediaTagsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListMediaTagsRequest.
 * Use `create(ListMediaTagsRequestSchema)` to create a new message.
 */
export const ListMediaTagsRequestSchema: GenMessage<ListMediaTagsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 22);

/**
 * @generated from message api_proto.v1.ListMediaTagsResponse
 */
export type ListMediaTagsResponse = Message<"api_proto.v1.ListMediaTagsResponse"> & {
  /**
   * 表示順（サイトの順。編集不可）
   *
   * @generated from field: repeated api_proto.v1.MediaTaxonomy tags = 1;
   */
  tags: MediaTaxonomy[];
};

/**
 * Describes the message api_proto.v1.ListMediaTagsResponse.
 * Use `create(ListMediaTagsResponseSchema)` to create a new message.
 */
export const ListMediaTagsResponseSchema: GenMessage<ListMediaTagsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 23);

/**
 * UpsertMediaTag（slug をキーに作成 / 更新）
 *
 * @generated from message api_proto.v1.UpsertMediaTagRequest
 */
export type UpsertMediaTagRequest = Message<"api_proto.v1.UpsertMediaTagRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message api_proto.v1.UpsertMediaTagRequest.
 * Use `create(UpsertMediaTagRequestSchema)` to create a new message.
 */
export const UpsertMediaTagRequestSchema: GenMessage<UpsertMediaTagRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 24);

/**
 * @generated from message api_proto.v1.UpsertMediaTagResponse
 */
export type UpsertMediaTagResponse = Message<"api_proto.v1.UpsertMediaTagResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaTaxonomy tag = 1;
   */
  tag?: MediaTaxonomy;
};

/**
 * Describes the message api_proto.v1.UpsertMediaTagResponse.
 * Use `create(UpsertMediaTagResponseSchema)` to create a new message.
 */
export const UpsertMediaTagResponseSchema: GenMessage<UpsertMediaTagResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 25);

/**
 * DeleteMediaTag（article_tags から参照されている場合は FailedPrecondition）
 *
 * @generated from message api_proto.v1.DeleteMediaTagRequest
 */
export type DeleteMediaTagRequest = Message<"api_proto.v1.DeleteMediaTagRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api_proto.v1.DeleteMediaTagRequest.
 * Use `create(DeleteMediaTagRequestSchema)` to create a new message.
 */
export const DeleteMediaTagRequestSchema: GenMessage<DeleteMediaTagRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 26);

/**
 * @generated from message api_proto.v1.DeleteMediaTagResponse
 */
export type DeleteMediaTagResponse = Message<"api_proto.v1.DeleteMediaTagResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteMediaTagResponse.
 * Use `create(DeleteMediaTagResponseSchema)` to create a new message.
 */
export const DeleteMediaTagResponseSchema: GenMessage<DeleteMediaTagResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 27);

/**
 * 記事の著者
 *
 * @generated from message api_proto.v1.MediaAuthor
 */
export type MediaAuthor = Message<"api_proto.v1.MediaAuthor"> & {
  /**
   * ULID (Crockford base32、26 文字)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 肩書き（例: 一級建築士 / 編集長）
   *
   * @generated from field: string role = 4;
   */
  role: string;

  /**
   * プロフィール本文（HTML）
   *
   * @generated from field: string bio_html = 5;
   */
  bioHtml: string;

  /**
   * @generated from field: string avatar_url = 6;
   */
  avatarUrl: string;

  /**
   * SNS リンク等の JSON
   *
   * @generated from field: string sns_json = 7;
   */
  snsJson: string;

  /**
   * アバター画像の alt テキスト（空 = 公開側は著者名でフォールバック）
   *
   * @generated from field: string avatar_alt = 8;
   */
  avatarAlt: string;
};

/**
 * Describes the message api_proto.v1.MediaAuthor.
 * Use `create(MediaAuthorSchema)` to create a new message.
 */
export const MediaAuthorSchema: GenMessage<MediaAuthor> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 28);

/**
 * ListMediaAuthors
 *
 * @generated from message api_proto.v1.ListMediaAuthorsRequest
 */
export type ListMediaAuthorsRequest = Message<"api_proto.v1.ListMediaAuthorsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListMediaAuthorsRequest.
 * Use `create(ListMediaAuthorsRequestSchema)` to create a new message.
 */
export const ListMediaAuthorsRequestSchema: GenMessage<ListMediaAuthorsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 29);

/**
 * @generated from message api_proto.v1.ListMediaAuthorsResponse
 */
export type ListMediaAuthorsResponse = Message<"api_proto.v1.ListMediaAuthorsResponse"> & {
  /**
   * 表示順（sort_order 昇順。編集不可）
   *
   * @generated from field: repeated api_proto.v1.MediaAuthor authors = 1;
   */
  authors: MediaAuthor[];
};

/**
 * Describes the message api_proto.v1.ListMediaAuthorsResponse.
 * Use `create(ListMediaAuthorsResponseSchema)` to create a new message.
 */
export const ListMediaAuthorsResponseSchema: GenMessage<ListMediaAuthorsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 30);

/**
 * GetMediaAuthor
 *
 * @generated from message api_proto.v1.GetMediaAuthorRequest
 */
export type GetMediaAuthorRequest = Message<"api_proto.v1.GetMediaAuthorRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api_proto.v1.GetMediaAuthorRequest.
 * Use `create(GetMediaAuthorRequestSchema)` to create a new message.
 */
export const GetMediaAuthorRequestSchema: GenMessage<GetMediaAuthorRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 31);

/**
 * @generated from message api_proto.v1.GetMediaAuthorResponse
 */
export type GetMediaAuthorResponse = Message<"api_proto.v1.GetMediaAuthorResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaAuthor author = 1;
   */
  author?: MediaAuthor;
};

/**
 * Describes the message api_proto.v1.GetMediaAuthorResponse.
 * Use `create(GetMediaAuthorResponseSchema)` to create a new message.
 */
export const GetMediaAuthorResponseSchema: GenMessage<GetMediaAuthorResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 32);

/**
 * UpsertMediaAuthor（slug をキーに作成 / 更新。新規時の id は ULID）
 *
 * @generated from message api_proto.v1.UpsertMediaAuthorRequest
 */
export type UpsertMediaAuthorRequest = Message<"api_proto.v1.UpsertMediaAuthorRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string role = 3;
   */
  role: string;

  /**
   * @generated from field: string bio_html = 4;
   */
  bioHtml: string;

  /**
   * @generated from field: string avatar_url = 5;
   */
  avatarUrl: string;

  /**
   * @generated from field: string sns_json = 6;
   */
  snsJson: string;

  /**
   * アバター画像の alt テキスト（空 = 公開側は著者名でフォールバック）
   *
   * @generated from field: string avatar_alt = 7;
   */
  avatarAlt: string;
};

/**
 * Describes the message api_proto.v1.UpsertMediaAuthorRequest.
 * Use `create(UpsertMediaAuthorRequestSchema)` to create a new message.
 */
export const UpsertMediaAuthorRequestSchema: GenMessage<UpsertMediaAuthorRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 33);

/**
 * @generated from message api_proto.v1.UpsertMediaAuthorResponse
 */
export type UpsertMediaAuthorResponse = Message<"api_proto.v1.UpsertMediaAuthorResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaAuthor author = 1;
   */
  author?: MediaAuthor;
};

/**
 * Describes the message api_proto.v1.UpsertMediaAuthorResponse.
 * Use `create(UpsertMediaAuthorResponseSchema)` to create a new message.
 */
export const UpsertMediaAuthorResponseSchema: GenMessage<UpsertMediaAuthorResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 34);

/**
 * DeleteMediaAuthor（記事 revision から参照されている場合は FailedPrecondition）
 *
 * @generated from message api_proto.v1.DeleteMediaAuthorRequest
 */
export type DeleteMediaAuthorRequest = Message<"api_proto.v1.DeleteMediaAuthorRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api_proto.v1.DeleteMediaAuthorRequest.
 * Use `create(DeleteMediaAuthorRequestSchema)` to create a new message.
 */
export const DeleteMediaAuthorRequestSchema: GenMessage<DeleteMediaAuthorRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 35);

/**
 * @generated from message api_proto.v1.DeleteMediaAuthorResponse
 */
export type DeleteMediaAuthorResponse = Message<"api_proto.v1.DeleteMediaAuthorResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteMediaAuthorResponse.
 * Use `create(DeleteMediaAuthorResponseSchema)` to create a new message.
 */
export const DeleteMediaAuthorResponseSchema: GenMessage<DeleteMediaAuthorResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 36);

/**
 * インタビュー（リビジョン管理なしの直接更新）
 *
 * @generated from message api_proto.v1.MediaInterview
 */
export type MediaInterview = Message<"api_proto.v1.MediaInterview"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string interviewee_name = 4;
   */
  intervieweeName: string;

  /**
   * @generated from field: string qualifications = 5;
   */
  qualifications: string;

  /**
   * @generated from field: string profile_html = 6;
   */
  profileHtml: string;

  /**
   * @generated from field: string avatar_url = 7;
   */
  avatarUrl: string;

  /**
   * @generated from field: string cover_url = 8;
   */
  coverUrl: string;

  /**
   * @generated from field: string body_html = 10;
   */
  bodyHtml: string;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 11;
   */
  publishedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * アバター画像の alt テキスト（空 = 公開側はインタビュイー名でフォールバック）
   *
   * @generated from field: string avatar_alt = 13;
   */
  avatarAlt: string;

  /**
   * カバー画像の alt テキスト（空 = 公開側はタイトルでフォールバック）
   *
   * @generated from field: string cover_alt = 14;
   */
  coverAlt: string;
};

/**
 * Describes the message api_proto.v1.MediaInterview.
 * Use `create(MediaInterviewSchema)` to create a new message.
 */
export const MediaInterviewSchema: GenMessage<MediaInterview> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 37);

/**
 * インタビュー一覧の 1 件（サマリ。body_html を含まない）
 *
 * @generated from message api_proto.v1.MediaInterviewSummary
 */
export type MediaInterviewSummary = Message<"api_proto.v1.MediaInterviewSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string interviewee_name = 4;
   */
  intervieweeName: string;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 5;
   */
  publishedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api_proto.v1.MediaInterviewSummary.
 * Use `create(MediaInterviewSummarySchema)` to create a new message.
 */
export const MediaInterviewSummarySchema: GenMessage<MediaInterviewSummary> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 38);

/**
 * ListMediaInterviews
 *
 * @generated from message api_proto.v1.ListMediaInterviewsRequest
 */
export type ListMediaInterviewsRequest = Message<"api_proto.v1.ListMediaInterviewsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListMediaInterviewsRequest.
 * Use `create(ListMediaInterviewsRequestSchema)` to create a new message.
 */
export const ListMediaInterviewsRequestSchema: GenMessage<ListMediaInterviewsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 39);

/**
 * @generated from message api_proto.v1.ListMediaInterviewsResponse
 */
export type ListMediaInterviewsResponse = Message<"api_proto.v1.ListMediaInterviewsResponse"> & {
  /**
   * published_at 降順
   *
   * @generated from field: repeated api_proto.v1.MediaInterviewSummary interviews = 1;
   */
  interviews: MediaInterviewSummary[];
};

/**
 * Describes the message api_proto.v1.ListMediaInterviewsResponse.
 * Use `create(ListMediaInterviewsResponseSchema)` to create a new message.
 */
export const ListMediaInterviewsResponseSchema: GenMessage<ListMediaInterviewsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 40);

/**
 * GetMediaInterview
 *
 * @generated from message api_proto.v1.GetMediaInterviewRequest
 */
export type GetMediaInterviewRequest = Message<"api_proto.v1.GetMediaInterviewRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api_proto.v1.GetMediaInterviewRequest.
 * Use `create(GetMediaInterviewRequestSchema)` to create a new message.
 */
export const GetMediaInterviewRequestSchema: GenMessage<GetMediaInterviewRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 41);

/**
 * @generated from message api_proto.v1.GetMediaInterviewResponse
 */
export type GetMediaInterviewResponse = Message<"api_proto.v1.GetMediaInterviewResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaInterview interview = 1;
   */
  interview?: MediaInterview;
};

/**
 * Describes the message api_proto.v1.GetMediaInterviewResponse.
 * Use `create(GetMediaInterviewResponseSchema)` to create a new message.
 */
export const GetMediaInterviewResponseSchema: GenMessage<GetMediaInterviewResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 42);

/**
 * UpsertMediaInterview（slug をキーに作成 / 更新。新規時の id は ULID、published_at は作成時に現在時刻を自動設定）
 *
 * @generated from message api_proto.v1.UpsertMediaInterviewRequest
 */
export type UpsertMediaInterviewRequest = Message<"api_proto.v1.UpsertMediaInterviewRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string interviewee_name = 3;
   */
  intervieweeName: string;

  /**
   * @generated from field: string qualifications = 4;
   */
  qualifications: string;

  /**
   * @generated from field: string profile_html = 5;
   */
  profileHtml: string;

  /**
   * @generated from field: string avatar_url = 6;
   */
  avatarUrl: string;

  /**
   * @generated from field: string cover_url = 7;
   */
  coverUrl: string;

  /**
   * @generated from field: string body_html = 9;
   */
  bodyHtml: string;

  /**
   * アバター画像の alt テキスト（空 = 公開側はインタビュイー名でフォールバック）
   *
   * @generated from field: string avatar_alt = 10;
   */
  avatarAlt: string;

  /**
   * カバー画像の alt テキスト（空 = 公開側はタイトルでフォールバック）
   *
   * @generated from field: string cover_alt = 11;
   */
  coverAlt: string;
};

/**
 * Describes the message api_proto.v1.UpsertMediaInterviewRequest.
 * Use `create(UpsertMediaInterviewRequestSchema)` to create a new message.
 */
export const UpsertMediaInterviewRequestSchema: GenMessage<UpsertMediaInterviewRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 43);

/**
 * @generated from message api_proto.v1.UpsertMediaInterviewResponse
 */
export type UpsertMediaInterviewResponse = Message<"api_proto.v1.UpsertMediaInterviewResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaInterview interview = 1;
   */
  interview?: MediaInterview;
};

/**
 * Describes the message api_proto.v1.UpsertMediaInterviewResponse.
 * Use `create(UpsertMediaInterviewResponseSchema)` to create a new message.
 */
export const UpsertMediaInterviewResponseSchema: GenMessage<UpsertMediaInterviewResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 44);

/**
 * DeleteMediaInterview（featured_items の該当行も同時に削除する）
 *
 * @generated from message api_proto.v1.DeleteMediaInterviewRequest
 */
export type DeleteMediaInterviewRequest = Message<"api_proto.v1.DeleteMediaInterviewRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message api_proto.v1.DeleteMediaInterviewRequest.
 * Use `create(DeleteMediaInterviewRequestSchema)` to create a new message.
 */
export const DeleteMediaInterviewRequestSchema: GenMessage<DeleteMediaInterviewRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 45);

/**
 * @generated from message api_proto.v1.DeleteMediaInterviewResponse
 */
export type DeleteMediaInterviewResponse = Message<"api_proto.v1.DeleteMediaInterviewResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteMediaInterviewResponse.
 * Use `create(DeleteMediaInterviewResponseSchema)` to create a new message.
 */
export const DeleteMediaInterviewResponseSchema: GenMessage<DeleteMediaInterviewResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 46);

/**
 * 工事対応可能エリア（都道府県 + 市区町村。prefecture はラベル文字列 例:"東京都"）
 *
 * @generated from message api_proto.v1.MediaRooferArea
 */
export type MediaRooferArea = Message<"api_proto.v1.MediaRooferArea"> & {
  /**
   * @generated from field: string prefecture = 1;
   */
  prefecture: string;

  /**
   * @generated from field: string city = 2;
   */
  city: string;
};

/**
 * Describes the message api_proto.v1.MediaRooferArea.
 * Use `create(MediaRooferAreaSchema)` to create a new message.
 */
export const MediaRooferAreaSchema: GenMessage<MediaRooferArea> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 47);

/**
 * 職人（認定店 1:N。upsert 時 full-replace）
 *
 * @generated from message api_proto.v1.MediaRooferCraftsman
 */
export type MediaRooferCraftsman = Message<"api_proto.v1.MediaRooferCraftsman"> & {
  /**
   * レスポンスのみ設定（full-replace のためリクエストでは無視）
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 氏名（必須）
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 写真（UploadMediaImage で取得した公開 URL、空可）
   *
   * @generated from field: string photo_url = 3;
   */
  photoUrl: string;

  /**
   * 資格（空 = 非表示）
   *
   * @generated from field: string qualifications = 4;
   */
  qualifications: string;

  /**
   * 受賞歴（空 = 非表示）
   *
   * @generated from field: string awards = 5;
   */
  awards: string;

  /**
   * 紹介文（空 = 非表示）
   *
   * @generated from field: string bio = 6;
   */
  bio: string;

  /**
   * 写真の alt テキスト（空 = 公開側は氏名でフォールバック）
   *
   * @generated from field: string photo_alt = 7;
   */
  photoAlt: string;
};

/**
 * Describes the message api_proto.v1.MediaRooferCraftsman.
 * Use `create(MediaRooferCraftsmanSchema)` to create a new message.
 */
export const MediaRooferCraftsmanSchema: GenMessage<MediaRooferCraftsman> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 48);

/**
 * 施工事例記事（認定店 1:N。upsert 時 full-replace）
 *
 * @generated from message api_proto.v1.MediaRooferCaseArticle
 */
export type MediaRooferCaseArticle = Message<"api_proto.v1.MediaRooferCaseArticle"> & {
  /**
   * レスポンスのみ設定（full-replace のためリクエストでは無視）
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 記事 URL（必須）
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * 記事タイトル（空可。FetchMediaUrlMetadata で自動補完できる）
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * サムネイル画像 URL（空可。FetchMediaUrlMetadata の記事キービジュアルで自動補完できる）
   *
   * @generated from field: string thumbnail_url = 4;
   */
  thumbnailUrl: string;

  /**
   * 以下 6 要素は施工事例ページのスペック欄から取得した「初期値」。
   * FetchMediaUrlMetadata で自動補完できるが、恒久参照ではなく Admin で自由に上書き編集できる（空可）。
   * エリア（例: 仙台市若林区）
   *
   * @generated from field: string area = 5;
   */
  area: string;

  /**
   * 工事費用（例: 30万円以下）
   *
   * @generated from field: string cost = 6;
   */
  cost: string;

  /**
   * 施工箇所（例: 大棟）
   *
   * @generated from field: string location = 7;
   */
  location: string;

  /**
   * 工事期間（例: 2日間）
   *
   * @generated from field: string period = 8;
   */
  period: string;

  /**
   * 施工内容（例: 大棟取り直し）
   *
   * @generated from field: string content = 9;
   */
  content: string;

  /**
   * 築年数（例: 40年程度）
   *
   * @generated from field: string building_age = 10;
   */
  buildingAge: string;

  /**
   * サムネイル画像の alt テキスト（空 = 公開側は記事タイトルでフォールバック）
   *
   * @generated from field: string thumbnail_alt = 11;
   */
  thumbnailAlt: string;
};

/**
 * Describes the message api_proto.v1.MediaRooferCaseArticle.
 * Use `create(MediaRooferCaseArticleSchema)` to create a new message.
 */
export const MediaRooferCaseArticleSchema: GenMessage<MediaRooferCaseArticle> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 49);

/**
 * 資格・受賞歴・加盟団体のマスター 1 件（カード = タイトル / 画像 / URL(任意)）
 *
 * @generated from message api_proto.v1.MediaCredentialItem
 */
export type MediaCredentialItem = Message<"api_proto.v1.MediaCredentialItem"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: api_proto.v1.MediaCredentialKind kind = 2;
   */
  kind: MediaCredentialKind;

  /**
   * タイトルテキスト（必須）
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * 画像（UploadMediaImage で取得した公開 URL、空可）
   *
   * @generated from field: string image_url = 4;
   */
  imageUrl: string;

  /**
   * リンク先 URL（任意）
   *
   * @generated from field: string url = 5;
   */
  url: string;

  /**
   * 画像の alt テキスト（空 = 公開側はタイトルでフォールバック）
   *
   * @generated from field: string image_alt = 6;
   */
  imageAlt: string;

  /**
   * 説明テキスト（オプショナル、空可。認定店個別ページで「?」から閲覧できる補足説明）
   *
   * @generated from field: string description = 7;
   */
  description: string;
};

/**
 * Describes the message api_proto.v1.MediaCredentialItem.
 * Use `create(MediaCredentialItemSchema)` to create a new message.
 */
export const MediaCredentialItemSchema: GenMessage<MediaCredentialItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 50);

/**
 * 認定店
 *
 * @generated from message api_proto.v1.MediaRoofer
 */
export type MediaRoofer = Message<"api_proto.v1.MediaRoofer"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string logo_url = 3;
   */
  logoUrl: string;

  /**
   * @generated from field: string prefecture = 4;
   */
  prefecture: string;

  /**
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * @generated from field: string works = 6;
   */
  works: string;

  /**
   * @generated from field: string homepage_url = 7;
   */
  homepageUrl: string;

  /**
   * 紐づくインタビュー記事の slug（空文字 = なし）
   *
   * @generated from field: string interview_slug = 8;
   */
  interviewSlug: string;

  /**
   * 個別ページ URL 用（^[a-z0-9-]+$、空 = 個別ページなし）
   *
   * @generated from field: string slug = 9;
   */
  slug: string;

  /**
   * ヒーロー画像（UploadMediaImage で取得した公開 URL、空可）
   *
   * @generated from field: string hero_image_url = 10;
   */
  heroImageUrl: string;

  /**
   * 工事を検討されている消費者へのメッセージ（リッチテキスト HTML。空 = 非表示。
   * 過去データはプレーンテキストの場合があり、表示側は `<` 始まりかで判定する）
   *
   * @generated from field: string message = 11;
   */
  message: string;

  /**
   * Google口コミ埋め込み iframe の src URL（全体評価。抽出・検証済み。空 = 非表示）
   *
   * @generated from field: string google_review_src = 12;
   */
  googleReviewSrc: string;

  /**
   * 連携するいえサプリ企業 ID（0 = 未連携）
   *
   * @generated from field: int64 iesapuri_company_id = 13;
   */
  iesapuriCompanyId: bigint;

  /**
   * 工事対応可能エリア（upsert 時 full-replace）
   *
   * @generated from field: repeated api_proto.v1.MediaRooferArea areas = 14;
   */
  areas: MediaRooferArea[];

  /**
   * 代表口コミ 1 件の iframe src URL（抽出・検証済み。空 = 非表示）
   *
   * @generated from field: string google_review_featured_src = 15;
   */
  googleReviewFeaturedSrc: string;

  /**
   * 職人（upsert 時 full-replace、配列順 = 表示順）
   *
   * @generated from field: repeated api_proto.v1.MediaRooferCraftsman craftsmen = 16;
   */
  craftsmen: MediaRooferCraftsman[];

  /**
   * 施工事例記事（upsert 時 full-replace、配列順 = 表示順）
   *
   * @generated from field: repeated api_proto.v1.MediaRooferCaseArticle case_articles = 17;
   */
  caseArticles: MediaRooferCaseArticle[];

  /**
   * アサイン済みの資格・受賞歴・加盟団体マスター ID（upsert 時 full-replace、配列順 = kind 内の表示順）
   *
   * @generated from field: repeated int64 credential_item_ids = 18;
   */
  credentialItemIds: bigint[];

  /**
   * Google Business Profile の Place ID（空 = 口コミ取得なし）
   *
   * @generated from field: string google_place_id = 19;
   */
  googlePlaceId: string;

  /**
   * 代表口コミの resource name（cached_reviews の name。空 = 未選択）
   *
   * @generated from field: string featured_review_name = 20;
   */
  featuredReviewName: string;

  /**
   * Places API 取得時の全体評価スナップショット（レスポンスのみ設定）
   *
   * @generated from field: double rating = 21;
   */
  rating: number;

  /**
   * @generated from field: int64 user_rating_count = 22;
   */
  userRatingCount: bigint;

  /**
   * D1 キャッシュ済みの口コミ（レスポンスのみ設定。リクエストでは無視）
   *
   * @generated from field: repeated api_proto.v1.MediaRooferReview cached_reviews = 23;
   */
  cachedReviews: MediaRooferReview[];

  /**
   * 個別ページの公開状態（レスポンスのみ設定。更新は UpdateMediaRooferPublished 経由。
   * upsert で更新可能にすると stale なフォーム保存で誤って公開状態が変わるため専用 RPC に分離）
   *
   * @generated from field: bool published = 24;
   */
  published: boolean;

  /**
   * --- 会社概要（すべて空 = 行非表示。ホームページは homepage_url を再利用） ---
   * 会社名（会社概要用。一覧カード・ヒーロー等で使う店名 name とは独立したデータ。空 = 会社名行を非表示）
   *
   * @generated from field: string company_name = 33;
   */
  companyName: string;

  /**
   * 代表取締役
   *
   * @generated from field: string representative = 25;
   */
  representative: string;

  /**
   * 本社所在地（表示用の完全住所。一覧カード用の prefecture / city とは独立）
   *
   * @generated from field: string address = 26;
   */
  address: string;

  /**
   * 電話番号
   *
   * @generated from field: string tel = 27;
   */
  tel: string;

  /**
   * FAX 番号
   *
   * @generated from field: string fax = 28;
   */
  fax: string;

  /**
   * メールアドレス
   *
   * @generated from field: string email = 29;
   */
  email: string;

  /**
   * 創業年（自由テキスト。例: "1950年（昭和25年）"）
   *
   * @generated from field: string founded_year = 30;
   */
  foundedYear: string;

  /**
   * 資本金（自由テキスト）
   *
   * @generated from field: string capital = 31;
   */
  capital: string;

  /**
   * 事業内容
   *
   * @generated from field: string business_description = 32;
   */
  businessDescription: string;

  /**
   * 消費者へのメッセージの発信者画像（UploadMediaImage の公開 URL、空 = 非表示。
   * 個別ページではメッセージ枠の左端に表示する。人物写真とロゴのどちらも入稿されるため、
   * 表示形は message_sender_image_fit で切り替える）
   *
   * @generated from field: string message_sender_image_url = 34;
   */
  messageSenderImageUrl: string;

  /**
   * ロゴ画像の alt テキスト（空 = 公開側は店名でフォールバック）
   *
   * @generated from field: string logo_alt = 35;
   */
  logoAlt: string;

  /**
   * ヒーロー画像の alt テキスト（空 = 公開側は店名でフォールバック）
   *
   * @generated from field: string hero_image_alt = 36;
   */
  heroImageAlt: string;

  /**
   * いえサプリ活用データ（レスポンスのみ。未取得なら未セット。更新は FetchMediaRooferUsageMetrics 経由）
   *
   * @generated from field: api_proto.v1.MediaRooferUsageMetrics usage_metrics = 37;
   */
  usageMetrics?: MediaRooferUsageMetrics;

  /**
   * 活用データセクションの公開ページ表示フラグ（レスポンスのみ。更新は UpdateMediaRooferUsageMetricsVisibility 経由。upsert では無視）
   *
   * @generated from field: bool usage_metrics_visible = 38;
   */
  usageMetricsVisible: boolean;

  /**
   * --- 認定店の分類（非排他。1 店が複数を兼ねうる） ---
   * published(24) / usage_metrics_visible(38) は「レスポンス専用 + 専用 RPC で更新」だが、
   * 分類は通常の upsert フィールドとして受ける。新規作成時には id が存在せず、専用 RPC にすると
   * 「分類ゼロで作成 → 直後に分類 RPC」の 2 段になり、その間どこにも表示されない不整合レコードが生まれるため。
   * published にこの問題がないのは「新規は非公開スタート」が正しいデフォルトだからで、
   * 分類には対応する自然なデフォルトがない（ゆえに upsert で 1 つ以上必須のバリデーションを課す）。
   * やねプロ認定店
   *
   * @generated from field: bool is_yanepro = 39;
   */
  isYanepro: boolean;

  /**
   * とそプロ認定店
   *
   * @generated from field: bool is_tosopro = 40;
   */
  isTosopro: boolean;

  /**
   * いえサプリ導入店。iesapuri_company_id（企業マスター連携 ID）とは独立した手動フラグであり、
   * そこから導出しない（連携なしで導入店バッジを出す / 連携済みでも出さないケースがあるため）
   *
   * @generated from field: bool is_iesapuri_adopter = 41;
   */
  isIesapuriAdopter: boolean;

  /**
   * 発信者画像の表示形（UNSPECIFIED = 画像の縦横比からの自動判定に任せる）
   *
   * @generated from field: api_proto.v1.MediaSenderImageFit message_sender_image_fit = 42;
   */
  messageSenderImageFit: MediaSenderImageFit;

  /**
   * AI活用度メーター（とそプロ一覧カード・個別ページ）の表示フラグ
   * （レスポンスのみ。更新は UpdateMediaRooferAiUsageVisibility 経由。upsert では無視）
   *
   * @generated from field: bool ai_usage_visible = 43;
   */
  aiUsageVisible: boolean;

  /**
   * 掲載状態。false の店は公開サイトのどこにも出ない（一覧カード・記事の差込ブロック・
   * 個別ページ・サイトマップ・お問い合わせの店名補完）。published は「掲載中の店の個別ページを
   * 出すか」で、掲載状態とは別の軸。新規作成した店は作成経路によらず false で始まる
   * （レスポンスのみ。更新は UpdateMediaRooferListed 経由。upsert では無視）
   *
   * @generated from field: bool listed = 44;
   */
  listed: boolean;
};

/**
 * Describes the message api_proto.v1.MediaRoofer.
 * Use `create(MediaRooferSchema)` to create a new message.
 */
export const MediaRooferSchema: GenMessage<MediaRoofer> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 51);

/**
 * いえサプリ活用データのスナップショット（FetchMediaRooferUsageMetrics で MySQL から計算して D1 に保存した値）
 *
 * @generated from message api_proto.v1.MediaRooferUsageMetrics
 */
export type MediaRooferUsageMetrics = Message<"api_proto.v1.MediaRooferUsageMetrics"> & {
  /**
   * 問合せ日→現調実施日の日数の中央値（直近1ヶ月・両日付あり・0〜365日・CSV/外部インポート案件除外）
   *
   * @generated from field: double speed_median_days = 1;
   */
  speedMedianDays: number;

  /**
   * 中央値の母数（両日付が揃った案件数）。公開ページは 5 未満をサンプル不足の参考値として注記付きで表示し、
   * 0 は「該当期間に値がありません」を表示する（箱自体は常設）
   *
   * @generated from field: int64 speed_sample_count = 2;
   */
  speedSampleCount: bigint;

  /**
   * 完工到達案件の累計数（公開ページでは非表示。Admin の確認表示・将来の再掲用に集計は継続）
   *
   * @generated from field: int64 completed_deal_count = 3;
   */
  completedDealCount: bigint;

  /**
   * 直近1ヶ月の新規登録顧客数
   *
   * @generated from field: int64 customer_count = 4;
   */
  customerCount: bigint;

  /**
   * 取得日時（RFC3339 UTC）
   *
   * @generated from field: string fetched_at = 5;
   */
  fetchedAt: string;

  /**
   * 直近90日の AIカラープロジェクト作成数（ai_color_projects を company_id + created 90日以内 + 未削除で集計）。
   * 低/中/高の判定は worker（フロント）側の定数で行うため、ここには生の件数のみを持つ。
   *
   * @generated from field: int64 ai_color_project_count_90d = 6;
   */
  aiColorProjectCount90d: bigint;

  /**
   * 直近90日の現調報告書作成数（survey_reports を deals JOIN で company に紐付け、created_at 90日以内 + 未削除で集計）。
   * AI活用度メーターは ai_color_project_count_90d との合算で判定する（判定は worker 側定数）。
   * 将来は AIプランのクレジット消費量（AIカラー10 / 報告書5 / 積算5）ベースへ移行予定
   *
   * @generated from field: int64 survey_report_count_90d = 7;
   */
  surveyReportCount90d: bigint;
};

/**
 * Describes the message api_proto.v1.MediaRooferUsageMetrics.
 * Use `create(MediaRooferUsageMetricsSchema)` to create a new message.
 */
export const MediaRooferUsageMetricsSchema: GenMessage<MediaRooferUsageMetrics> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 52);

/**
 * Places API から取得してキャッシュした口コミ 1 件
 *
 * @generated from message api_proto.v1.MediaRooferReview
 */
export type MediaRooferReview = Message<"api_proto.v1.MediaRooferReview"> & {
  /**
   * Places API の review resource name（places/{place}/reviews/{review}）
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int32 rating = 2;
   */
  rating: number;

  /**
   * @generated from field: string text = 3;
   */
  text: string;

  /**
   * @generated from field: string author_name = 4;
   */
  authorName: string;

  /**
   * @generated from field: string author_photo_url = 5;
   */
  authorPhotoUrl: string;

  /**
   * 例: "2 か月前"
   *
   * @generated from field: string relative_time = 6;
   */
  relativeTime: string;

  /**
   * RFC3339
   *
   * @generated from field: string publish_time = 7;
   */
  publishTime: string;

  /**
   * レビューへの Google Maps リンク（帰属表示用）
   *
   * @generated from field: string google_maps_uri = 8;
   */
  googleMapsUri: string;
};

/**
 * Describes the message api_proto.v1.MediaRooferReview.
 * Use `create(MediaRooferReviewSchema)` to create a new message.
 */
export const MediaRooferReviewSchema: GenMessage<MediaRooferReview> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 53);

/**
 * ListMediaRoofers
 *
 * @generated from message api_proto.v1.ListMediaRoofersRequest
 */
export type ListMediaRoofersRequest = Message<"api_proto.v1.ListMediaRoofersRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListMediaRoofersRequest.
 * Use `create(ListMediaRoofersRequestSchema)` to create a new message.
 */
export const ListMediaRoofersRequestSchema: GenMessage<ListMediaRoofersRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 54);

/**
 * @generated from message api_proto.v1.ListMediaRoofersResponse
 */
export type ListMediaRoofersResponse = Message<"api_proto.v1.ListMediaRoofersResponse"> & {
  /**
   * 登録順（新規は末尾）
   *
   * @generated from field: repeated api_proto.v1.MediaRoofer roofers = 1;
   */
  roofers: MediaRoofer[];
};

/**
 * Describes the message api_proto.v1.ListMediaRoofersResponse.
 * Use `create(ListMediaRoofersResponseSchema)` to create a new message.
 */
export const ListMediaRoofersResponseSchema: GenMessage<ListMediaRoofersResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 55);

/**
 * UpsertMediaRoofer（id = 0 で新規作成、それ以外は更新）
 *
 * @generated from message api_proto.v1.UpsertMediaRooferRequest
 */
export type UpsertMediaRooferRequest = Message<"api_proto.v1.UpsertMediaRooferRequest"> & {
  /**
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.UpsertMediaRooferRequest.
 * Use `create(UpsertMediaRooferRequestSchema)` to create a new message.
 */
export const UpsertMediaRooferRequestSchema: GenMessage<UpsertMediaRooferRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 56);

/**
 * @generated from message api_proto.v1.UpsertMediaRooferResponse
 */
export type UpsertMediaRooferResponse = Message<"api_proto.v1.UpsertMediaRooferResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.UpsertMediaRooferResponse.
 * Use `create(UpsertMediaRooferResponseSchema)` to create a new message.
 */
export const UpsertMediaRooferResponseSchema: GenMessage<UpsertMediaRooferResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 57);

/**
 * GetMediaRoofer（認定店1件。存在しないidはNotFound）
 *
 * @generated from message api_proto.v1.GetMediaRooferRequest
 */
export type GetMediaRooferRequest = Message<"api_proto.v1.GetMediaRooferRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.GetMediaRooferRequest.
 * Use `create(GetMediaRooferRequestSchema)` to create a new message.
 */
export const GetMediaRooferRequestSchema: GenMessage<GetMediaRooferRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 58);

/**
 * @generated from message api_proto.v1.GetMediaRooferResponse
 */
export type GetMediaRooferResponse = Message<"api_proto.v1.GetMediaRooferResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.GetMediaRooferResponse.
 * Use `create(GetMediaRooferResponseSchema)` to create a new message.
 */
export const GetMediaRooferResponseSchema: GenMessage<GetMediaRooferResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 59);

/**
 * UpdateMediaRooferFields（列単位の部分更新）
 *
 * update_maskに列挙したスカラー列だけを単文UPDATEで更新する部分更新。
 * 子配列（areas / craftsmen / case_articles / credential_item_ids。UpdateMediaRooferChildrenの領域）、
 * レスポンス専用フィールド（published / listed / usage_metrics_visible / ai_usage_visible /
 * rating / user_rating_count / cached_reviews / usage_metrics。それぞれ専用RPCの領域）、
 * google_place_id（FetchMediaRooferReviewsが取得に成功したときだけ保存する）をmaskに含めた場合はInvalidArgument。
 * slugは個別ページが公開中（published）の店では変更できない（公開URLが変わるため。FailedPrecondition / MEDIA_ROOFER_SLUG_LOCKED）。
 * 分類（is_*）は掲載中（listed）または個別ページが公開中の店では変更できない（どの一覧に載るか・個別ページを出すかが
 * 人の判断なしに変わるため。FailedPrecondition / MEDIA_ROOFER_CATEGORY_LOCKED）。
 * 分類（is_*）は更新後も1つ以上残っていなければならない。
 * 既存のUpsertMediaRoofer（全置換）とは別に、AI経由の列単位更新のために追加した
 *
 * @generated from message api_proto.v1.UpdateMediaRooferFieldsRequest
 */
export type UpdateMediaRooferFieldsRequest = Message<"api_proto.v1.UpdateMediaRooferFieldsRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 更新する値（update_maskに列挙したフィールドのみ読む）
   *
   * @generated from field: api_proto.v1.MediaRoofer roofer = 2;
   */
  roofer?: MediaRoofer;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferFieldsRequest.
 * Use `create(UpdateMediaRooferFieldsRequestSchema)` to create a new message.
 */
export const UpdateMediaRooferFieldsRequestSchema: GenMessage<UpdateMediaRooferFieldsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 60);

/**
 * @generated from message api_proto.v1.UpdateMediaRooferFieldsResponse
 */
export type UpdateMediaRooferFieldsResponse = Message<"api_proto.v1.UpdateMediaRooferFieldsResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferFieldsResponse.
 * Use `create(UpdateMediaRooferFieldsResponseSchema)` to create a new message.
 */
export const UpdateMediaRooferFieldsResponseSchema: GenMessage<UpdateMediaRooferFieldsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 61);

/**
 * CreateMediaRooferFields（列を指定した新規作成）
 *
 * field_maskに列挙したスカラー列だけを値として受け取り、認定店を新規作成する。受け付ける列・
 * 値の検証はUpdateMediaRooferFieldsと同じ（画像URLは台帳登録済みのものに限る）。nameと分類（is_*を1つ以上）は必須。
 * 作成した店は掲載状態 listed = false・個別ページ published = false で始まり、公開サイトには出ない。
 * 子配列は作成後にUpdateMediaRooferChildrenで入れる
 *
 * @generated from message api_proto.v1.CreateMediaRooferFieldsRequest
 */
export type CreateMediaRooferFieldsRequest = Message<"api_proto.v1.CreateMediaRooferFieldsRequest"> & {
  /**
   * 作成する値（field_maskに列挙したフィールドのみ読む。idは無視）
   *
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;

  /**
   * @generated from field: google.protobuf.FieldMask field_mask = 2;
   */
  fieldMask?: FieldMask;
};

/**
 * Describes the message api_proto.v1.CreateMediaRooferFieldsRequest.
 * Use `create(CreateMediaRooferFieldsRequestSchema)` to create a new message.
 */
export const CreateMediaRooferFieldsRequestSchema: GenMessage<CreateMediaRooferFieldsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 62);

/**
 * @generated from message api_proto.v1.CreateMediaRooferFieldsResponse
 */
export type CreateMediaRooferFieldsResponse = Message<"api_proto.v1.CreateMediaRooferFieldsResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.CreateMediaRooferFieldsResponse.
 * Use `create(CreateMediaRooferFieldsResponseSchema)` to create a new message.
 */
export const CreateMediaRooferFieldsResponseSchema: GenMessage<CreateMediaRooferFieldsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 63);

/**
 * UpdateMediaRooferChildren（子配列の置換）
 *
 * update_maskに列挙した子配列（areas / craftsmen / case_articles / credential_item_ids）だけを
 * 配列ごとに全置換する。列挙しなかった子配列とroofers行は変化しない。値の検証はUpsertMediaRooferと同じに加え、
 * 画像URL（職人の photo_url / 施工事例の thumbnail_url）は台帳登録済みか、その認定店の同じ種類の
 * 子配列に現在入っているURLに限る
 *
 * @generated from message api_proto.v1.UpdateMediaRooferChildrenRequest
 */
export type UpdateMediaRooferChildrenRequest = Message<"api_proto.v1.UpdateMediaRooferChildrenRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 置換後の値（update_maskに列挙した子配列のみ読む）
   *
   * @generated from field: api_proto.v1.MediaRoofer roofer = 2;
   */
  roofer?: MediaRoofer;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferChildrenRequest.
 * Use `create(UpdateMediaRooferChildrenRequestSchema)` to create a new message.
 */
export const UpdateMediaRooferChildrenRequestSchema: GenMessage<UpdateMediaRooferChildrenRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 64);

/**
 * @generated from message api_proto.v1.UpdateMediaRooferChildrenResponse
 */
export type UpdateMediaRooferChildrenResponse = Message<"api_proto.v1.UpdateMediaRooferChildrenResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferChildrenResponse.
 * Use `create(UpdateMediaRooferChildrenResponseSchema)` to create a new message.
 */
export const UpdateMediaRooferChildrenResponseSchema: GenMessage<UpdateMediaRooferChildrenResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 65);

/**
 * DeleteMediaRoofer
 *
 * @generated from message api_proto.v1.DeleteMediaRooferRequest
 */
export type DeleteMediaRooferRequest = Message<"api_proto.v1.DeleteMediaRooferRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteMediaRooferRequest.
 * Use `create(DeleteMediaRooferRequestSchema)` to create a new message.
 */
export const DeleteMediaRooferRequestSchema: GenMessage<DeleteMediaRooferRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 66);

/**
 * @generated from message api_proto.v1.DeleteMediaRooferResponse
 */
export type DeleteMediaRooferResponse = Message<"api_proto.v1.DeleteMediaRooferResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteMediaRooferResponse.
 * Use `create(DeleteMediaRooferResponseSchema)` to create a new message.
 */
export const DeleteMediaRooferResponseSchema: GenMessage<DeleteMediaRooferResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 67);

/**
 * UpdateMediaRooferPublished（個別ページの公開状態のみを切り替える）
 *
 * @generated from message api_proto.v1.UpdateMediaRooferPublishedRequest
 */
export type UpdateMediaRooferPublishedRequest = Message<"api_proto.v1.UpdateMediaRooferPublishedRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: bool published = 2;
   */
  published: boolean;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferPublishedRequest.
 * Use `create(UpdateMediaRooferPublishedRequestSchema)` to create a new message.
 */
export const UpdateMediaRooferPublishedRequestSchema: GenMessage<UpdateMediaRooferPublishedRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 68);

/**
 * @generated from message api_proto.v1.UpdateMediaRooferPublishedResponse
 */
export type UpdateMediaRooferPublishedResponse = Message<"api_proto.v1.UpdateMediaRooferPublishedResponse"> & {
  /**
   * 更新後の認定店
   *
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferPublishedResponse.
 * Use `create(UpdateMediaRooferPublishedResponseSchema)` to create a new message.
 */
export const UpdateMediaRooferPublishedResponseSchema: GenMessage<UpdateMediaRooferPublishedResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 69);

/**
 * UpdateMediaRooferListed（掲載状態のみを切り替える）
 *
 * @generated from message api_proto.v1.UpdateMediaRooferListedRequest
 */
export type UpdateMediaRooferListedRequest = Message<"api_proto.v1.UpdateMediaRooferListedRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: bool listed = 2;
   */
  listed: boolean;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferListedRequest.
 * Use `create(UpdateMediaRooferListedRequestSchema)` to create a new message.
 */
export const UpdateMediaRooferListedRequestSchema: GenMessage<UpdateMediaRooferListedRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 70);

/**
 * @generated from message api_proto.v1.UpdateMediaRooferListedResponse
 */
export type UpdateMediaRooferListedResponse = Message<"api_proto.v1.UpdateMediaRooferListedResponse"> & {
  /**
   * 更新後の認定店
   *
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferListedResponse.
 * Use `create(UpdateMediaRooferListedResponseSchema)` to create a new message.
 */
export const UpdateMediaRooferListedResponseSchema: GenMessage<UpdateMediaRooferListedResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 71);

/**
 * ListMediaCredentialItems（資格・受賞歴・加盟団体マスターの全件。kind 問わず登録順）
 *
 * @generated from message api_proto.v1.ListMediaCredentialItemsRequest
 */
export type ListMediaCredentialItemsRequest = Message<"api_proto.v1.ListMediaCredentialItemsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListMediaCredentialItemsRequest.
 * Use `create(ListMediaCredentialItemsRequestSchema)` to create a new message.
 */
export const ListMediaCredentialItemsRequestSchema: GenMessage<ListMediaCredentialItemsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 72);

/**
 * @generated from message api_proto.v1.ListMediaCredentialItemsResponse
 */
export type ListMediaCredentialItemsResponse = Message<"api_proto.v1.ListMediaCredentialItemsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.MediaCredentialItem items = 1;
   */
  items: MediaCredentialItem[];
};

/**
 * Describes the message api_proto.v1.ListMediaCredentialItemsResponse.
 * Use `create(ListMediaCredentialItemsResponseSchema)` to create a new message.
 */
export const ListMediaCredentialItemsResponseSchema: GenMessage<ListMediaCredentialItemsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 73);

/**
 * UpsertMediaCredentialItem（id = 0 で新規作成、それ以外は更新）
 *
 * @generated from message api_proto.v1.UpsertMediaCredentialItemRequest
 */
export type UpsertMediaCredentialItemRequest = Message<"api_proto.v1.UpsertMediaCredentialItemRequest"> & {
  /**
   * @generated from field: api_proto.v1.MediaCredentialItem item = 1;
   */
  item?: MediaCredentialItem;
};

/**
 * Describes the message api_proto.v1.UpsertMediaCredentialItemRequest.
 * Use `create(UpsertMediaCredentialItemRequestSchema)` to create a new message.
 */
export const UpsertMediaCredentialItemRequestSchema: GenMessage<UpsertMediaCredentialItemRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 74);

/**
 * @generated from message api_proto.v1.UpsertMediaCredentialItemResponse
 */
export type UpsertMediaCredentialItemResponse = Message<"api_proto.v1.UpsertMediaCredentialItemResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaCredentialItem item = 1;
   */
  item?: MediaCredentialItem;
};

/**
 * Describes the message api_proto.v1.UpsertMediaCredentialItemResponse.
 * Use `create(UpsertMediaCredentialItemResponseSchema)` to create a new message.
 */
export const UpsertMediaCredentialItemResponseSchema: GenMessage<UpsertMediaCredentialItemResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 75);

/**
 * DeleteMediaCredentialItem（認定店にアサイン中は FailedPrecondition）
 *
 * @generated from message api_proto.v1.DeleteMediaCredentialItemRequest
 */
export type DeleteMediaCredentialItemRequest = Message<"api_proto.v1.DeleteMediaCredentialItemRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteMediaCredentialItemRequest.
 * Use `create(DeleteMediaCredentialItemRequestSchema)` to create a new message.
 */
export const DeleteMediaCredentialItemRequestSchema: GenMessage<DeleteMediaCredentialItemRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 76);

/**
 * @generated from message api_proto.v1.DeleteMediaCredentialItemResponse
 */
export type DeleteMediaCredentialItemResponse = Message<"api_proto.v1.DeleteMediaCredentialItemResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteMediaCredentialItemResponse.
 * Use `create(DeleteMediaCredentialItemResponseSchema)` to create a new message.
 */
export const DeleteMediaCredentialItemResponseSchema: GenMessage<DeleteMediaCredentialItemResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 77);

/**
 * FetchMediaRooferUsageMetrics（いえサプリの案件データを MySQL から計算して D1 に保存し返す。
 * roofer に iesapuri_company_id が未設定の場合は MEDIA_ROOFER_COMPANY_LINK_REQUIRED の InvalidArgument）
 *
 * @generated from message api_proto.v1.FetchMediaRooferUsageMetricsRequest
 */
export type FetchMediaRooferUsageMetricsRequest = Message<"api_proto.v1.FetchMediaRooferUsageMetricsRequest"> & {
  /**
   * @generated from field: int64 roofer_id = 1;
   */
  rooferId: bigint;
};

/**
 * Describes the message api_proto.v1.FetchMediaRooferUsageMetricsRequest.
 * Use `create(FetchMediaRooferUsageMetricsRequestSchema)` to create a new message.
 */
export const FetchMediaRooferUsageMetricsRequestSchema: GenMessage<FetchMediaRooferUsageMetricsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 78);

/**
 * @generated from message api_proto.v1.FetchMediaRooferUsageMetricsResponse
 */
export type FetchMediaRooferUsageMetricsResponse = Message<"api_proto.v1.FetchMediaRooferUsageMetricsResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaRooferUsageMetrics metrics = 1;
   */
  metrics?: MediaRooferUsageMetrics;
};

/**
 * Describes the message api_proto.v1.FetchMediaRooferUsageMetricsResponse.
 * Use `create(FetchMediaRooferUsageMetricsResponseSchema)` to create a new message.
 */
export const FetchMediaRooferUsageMetricsResponseSchema: GenMessage<FetchMediaRooferUsageMetricsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 79);

/**
 * UpdateMediaRooferUsageMetricsVisibility（活用データセクションの表示/非表示のみを切り替える専用 RPC）
 *
 * @generated from message api_proto.v1.UpdateMediaRooferUsageMetricsVisibilityRequest
 */
export type UpdateMediaRooferUsageMetricsVisibilityRequest = Message<"api_proto.v1.UpdateMediaRooferUsageMetricsVisibilityRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: bool visible = 2;
   */
  visible: boolean;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferUsageMetricsVisibilityRequest.
 * Use `create(UpdateMediaRooferUsageMetricsVisibilityRequestSchema)` to create a new message.
 */
export const UpdateMediaRooferUsageMetricsVisibilityRequestSchema: GenMessage<UpdateMediaRooferUsageMetricsVisibilityRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 80);

/**
 * @generated from message api_proto.v1.UpdateMediaRooferUsageMetricsVisibilityResponse
 */
export type UpdateMediaRooferUsageMetricsVisibilityResponse = Message<"api_proto.v1.UpdateMediaRooferUsageMetricsVisibilityResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferUsageMetricsVisibilityResponse.
 * Use `create(UpdateMediaRooferUsageMetricsVisibilityResponseSchema)` to create a new message.
 */
export const UpdateMediaRooferUsageMetricsVisibilityResponseSchema: GenMessage<UpdateMediaRooferUsageMetricsVisibilityResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 81);

/**
 * UpdateMediaRooferAiUsageVisibility（AI活用度メーターの表示/非表示のみを切り替える専用 RPC）
 *
 * @generated from message api_proto.v1.UpdateMediaRooferAiUsageVisibilityRequest
 */
export type UpdateMediaRooferAiUsageVisibilityRequest = Message<"api_proto.v1.UpdateMediaRooferAiUsageVisibilityRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: bool visible = 2;
   */
  visible: boolean;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferAiUsageVisibilityRequest.
 * Use `create(UpdateMediaRooferAiUsageVisibilityRequestSchema)` to create a new message.
 */
export const UpdateMediaRooferAiUsageVisibilityRequestSchema: GenMessage<UpdateMediaRooferAiUsageVisibilityRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 82);

/**
 * @generated from message api_proto.v1.UpdateMediaRooferAiUsageVisibilityResponse
 */
export type UpdateMediaRooferAiUsageVisibilityResponse = Message<"api_proto.v1.UpdateMediaRooferAiUsageVisibilityResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.UpdateMediaRooferAiUsageVisibilityResponse.
 * Use `create(UpdateMediaRooferAiUsageVisibilityResponseSchema)` to create a new message.
 */
export const UpdateMediaRooferAiUsageVisibilityResponseSchema: GenMessage<UpdateMediaRooferAiUsageVisibilityResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 83);

/**
 * FetchMediaRooferReviews（Places API から口コミ上位 5 件を取得して D1 にキャッシュし返す。
 * google_place_id で指定した Place ID を使って取得し、成功時にその ID を roofer へ保存する
 * （取得 = 検証 + 保存）。google_place_id が空の場合は roofer の保存済み ID にフォールバック
 * （バッチ更新・旧クライアント互換）。両方空は MEDIA_ROOFER_PLACE_ID_REQUIRED、
 * Places API が 4xx を返す ID は MEDIA_ROOFER_PLACE_ID_INVALID。PLACES_API_KEY 未設定時はエラー）
 *
 * @generated from message api_proto.v1.FetchMediaRooferReviewsRequest
 */
export type FetchMediaRooferReviewsRequest = Message<"api_proto.v1.FetchMediaRooferReviewsRequest"> & {
  /**
   * @generated from field: int64 roofer_id = 1;
   */
  rooferId: bigint;

  /**
   * 取得に使う Place ID（空 = roofer の保存済み ID を使用）
   *
   * @generated from field: string google_place_id = 2;
   */
  googlePlaceId: string;
};

/**
 * Describes the message api_proto.v1.FetchMediaRooferReviewsRequest.
 * Use `create(FetchMediaRooferReviewsRequestSchema)` to create a new message.
 */
export const FetchMediaRooferReviewsRequestSchema: GenMessage<FetchMediaRooferReviewsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 84);

/**
 * @generated from message api_proto.v1.FetchMediaRooferReviewsResponse
 */
export type FetchMediaRooferReviewsResponse = Message<"api_proto.v1.FetchMediaRooferReviewsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.MediaRooferReview reviews = 1;
   */
  reviews: MediaRooferReview[];

  /**
   * @generated from field: double rating = 2;
   */
  rating: number;

  /**
   * @generated from field: int64 user_rating_count = 3;
   */
  userRatingCount: bigint;
};

/**
 * Describes the message api_proto.v1.FetchMediaRooferReviewsResponse.
 * Use `create(FetchMediaRooferReviewsResponseSchema)` to create a new message.
 */
export const FetchMediaRooferReviewsResponseSchema: GenMessage<FetchMediaRooferReviewsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 85);

/**
 * ClearMediaRooferReviews（認定店の Google 口コミの掲載をやめる。
 * roofers の google_place_id / featured_review_name を空、rating / user_rating_count を 0 にし、
 * 口コミキャッシュ（roofer_reviews）を削除する。公開ページの「Google での口コミ」欄と一覧カードの星が消え、
 * Place ID が空になるので口コミ一括更新バッチの対象からも外れる。再開は FetchMediaRooferReviews で取り直す。
 * 何度呼んでも同じ結果になる。存在しない roofer_id は NotFound）
 *
 * @generated from message api_proto.v1.ClearMediaRooferReviewsRequest
 */
export type ClearMediaRooferReviewsRequest = Message<"api_proto.v1.ClearMediaRooferReviewsRequest"> & {
  /**
   * @generated from field: int64 roofer_id = 1;
   */
  rooferId: bigint;
};

/**
 * Describes the message api_proto.v1.ClearMediaRooferReviewsRequest.
 * Use `create(ClearMediaRooferReviewsRequestSchema)` to create a new message.
 */
export const ClearMediaRooferReviewsRequestSchema: GenMessage<ClearMediaRooferReviewsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 86);

/**
 * @generated from message api_proto.v1.ClearMediaRooferReviewsResponse
 */
export type ClearMediaRooferReviewsResponse = Message<"api_proto.v1.ClearMediaRooferReviewsResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaRoofer roofer = 1;
   */
  roofer?: MediaRoofer;
};

/**
 * Describes the message api_proto.v1.ClearMediaRooferReviewsResponse.
 * Use `create(ClearMediaRooferReviewsResponseSchema)` to create a new message.
 */
export const ClearMediaRooferReviewsResponseSchema: GenMessage<ClearMediaRooferReviewsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 87);

/**
 * FetchMediaUrlMetadata（施工事例カードの入力省力化: URL 先ページの OGP メタデータを取得）
 *
 * @generated from message api_proto.v1.FetchMediaUrlMetadataRequest
 */
export type FetchMediaUrlMetadataRequest = Message<"api_proto.v1.FetchMediaUrlMetadataRequest"> & {
  /**
   * 取得先 URL（https のみ）
   *
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message api_proto.v1.FetchMediaUrlMetadataRequest.
 * Use `create(FetchMediaUrlMetadataRequestSchema)` to create a new message.
 */
export const FetchMediaUrlMetadataRequestSchema: GenMessage<FetchMediaUrlMetadataRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 88);

/**
 * @generated from message api_proto.v1.FetchMediaUrlMetadataResponse
 */
export type FetchMediaUrlMetadataResponse = Message<"api_proto.v1.FetchMediaUrlMetadataResponse"> & {
  /**
   * og:title（なければ <title>。取得できなければ空文字）
   *
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * 記事キービジュアル画像の URL（本文の主要画像を優先し、なければ og:image。取得できなければ空文字）
   *
   * @generated from field: string image_url = 2;
   */
  imageUrl: string;

  /**
   * 施工事例ページのスペック欄から抽出した 6 要素（取得できなければ空文字）
   * エリア
   *
   * @generated from field: string area = 3;
   */
  area: string;

  /**
   * 工事費用
   *
   * @generated from field: string cost = 4;
   */
  cost: string;

  /**
   * 施工箇所
   *
   * @generated from field: string location = 5;
   */
  location: string;

  /**
   * 工事期間
   *
   * @generated from field: string period = 6;
   */
  period: string;

  /**
   * 施工内容
   *
   * @generated from field: string content = 7;
   */
  content: string;

  /**
   * 築年数
   *
   * @generated from field: string building_age = 8;
   */
  buildingAge: string;
};

/**
 * Describes the message api_proto.v1.FetchMediaUrlMetadataResponse.
 * Use `create(FetchMediaUrlMetadataResponseSchema)` to create a new message.
 */
export const FetchMediaUrlMetadataResponseSchema: GenMessage<FetchMediaUrlMetadataResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 89);

/**
 * 掲載枠の 1 件
 *
 * @generated from message api_proto.v1.MediaFeaturedItem
 */
export type MediaFeaturedItem = Message<"api_proto.v1.MediaFeaturedItem"> & {
  /**
   * article | interview
   *
   * @generated from field: string content_type = 1;
   */
  contentType: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * 表示用タイトル（レスポンスのみ設定。リクエストでは無視）
   *
   * @generated from field: string title = 3;
   */
  title: string;
};

/**
 * Describes the message api_proto.v1.MediaFeaturedItem.
 * Use `create(MediaFeaturedItemSchema)` to create a new message.
 */
export const MediaFeaturedItemSchema: GenMessage<MediaFeaturedItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 90);

/**
 * ListMediaFeaturedItems（全 kind をまとめて返す）
 *
 * @generated from message api_proto.v1.ListMediaFeaturedItemsRequest
 */
export type ListMediaFeaturedItemsRequest = Message<"api_proto.v1.ListMediaFeaturedItemsRequest"> & {
};

/**
 * Describes the message api_proto.v1.ListMediaFeaturedItemsRequest.
 * Use `create(ListMediaFeaturedItemsRequestSchema)` to create a new message.
 */
export const ListMediaFeaturedItemsRequestSchema: GenMessage<ListMediaFeaturedItemsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 91);

/**
 * @generated from message api_proto.v1.MediaFeaturedGroup
 */
export type MediaFeaturedGroup = Message<"api_proto.v1.MediaFeaturedGroup"> & {
  /**
   * popular / pickup 等
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * position 昇順
   *
   * @generated from field: repeated api_proto.v1.MediaFeaturedItem items = 2;
   */
  items: MediaFeaturedItem[];
};

/**
 * Describes the message api_proto.v1.MediaFeaturedGroup.
 * Use `create(MediaFeaturedGroupSchema)` to create a new message.
 */
export const MediaFeaturedGroupSchema: GenMessage<MediaFeaturedGroup> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 92);

/**
 * @generated from message api_proto.v1.ListMediaFeaturedItemsResponse
 */
export type ListMediaFeaturedItemsResponse = Message<"api_proto.v1.ListMediaFeaturedItemsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.MediaFeaturedGroup groups = 1;
   */
  groups: MediaFeaturedGroup[];
};

/**
 * Describes the message api_proto.v1.ListMediaFeaturedItemsResponse.
 * Use `create(ListMediaFeaturedItemsResponseSchema)` to create a new message.
 */
export const ListMediaFeaturedItemsResponseSchema: GenMessage<ListMediaFeaturedItemsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 93);

/**
 * SetMediaFeaturedItems（kind 単位の全置換。position は配列順で採番）
 *
 * @generated from message api_proto.v1.SetMediaFeaturedItemsRequest
 */
export type SetMediaFeaturedItemsRequest = Message<"api_proto.v1.SetMediaFeaturedItemsRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: repeated api_proto.v1.MediaFeaturedItem items = 2;
   */
  items: MediaFeaturedItem[];
};

/**
 * Describes the message api_proto.v1.SetMediaFeaturedItemsRequest.
 * Use `create(SetMediaFeaturedItemsRequestSchema)` to create a new message.
 */
export const SetMediaFeaturedItemsRequestSchema: GenMessage<SetMediaFeaturedItemsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 94);

/**
 * @generated from message api_proto.v1.SetMediaFeaturedItemsResponse
 */
export type SetMediaFeaturedItemsResponse = Message<"api_proto.v1.SetMediaFeaturedItemsResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaFeaturedGroup group = 1;
   */
  group?: MediaFeaturedGroup;
};

/**
 * Describes the message api_proto.v1.SetMediaFeaturedItemsResponse.
 * Use `create(SetMediaFeaturedItemsResponseSchema)` to create a new message.
 */
export const SetMediaFeaturedItemsResponseSchema: GenMessage<SetMediaFeaturedItemsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 95);

/**
 * UploadMediaImage（公開 R2 の media ディレクトリへアップロードし公開 URL を返す）
 *
 * @generated from message api_proto.v1.UploadMediaImageRequest
 */
export type UploadMediaImageRequest = Message<"api_proto.v1.UploadMediaImageRequest"> & {
  /**
   * file_name + data（file.proto の Upload）
   *
   * @generated from field: api_proto.v1.Upload image = 1;
   */
  image?: Upload;
};

/**
 * Describes the message api_proto.v1.UploadMediaImageRequest.
 * Use `create(UploadMediaImageRequestSchema)` to create a new message.
 */
export const UploadMediaImageRequestSchema: GenMessage<UploadMediaImageRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 96);

/**
 * @generated from message api_proto.v1.UploadMediaImageResponse
 */
export type UploadMediaImageResponse = Message<"api_proto.v1.UploadMediaImageResponse"> & {
  /**
   * 公開 URL（https://{書き込み先バケットの公開ドメイン}/{key}）。cover_url や本文 <img src> にそのまま使える
   * （ドメインは FS_BUCKET_DOMAIN_MAP でバケット名から解決。未設定時は FS_IMAGE_BUCKET_DOMAIN）
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * R2 オブジェクトキー（media/uploads/{ulid}/{sanitized-filename}）
   *
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * アップロードと同時に画像キャビネット台帳へ自動登録されたレコード
   *
   * @generated from field: api_proto.v1.MediaImage image = 3;
   */
  image?: MediaImage;
};

/**
 * Describes the message api_proto.v1.UploadMediaImageResponse.
 * Use `create(UploadMediaImageResponseSchema)` to create a new message.
 */
export const UploadMediaImageResponseSchema: GenMessage<UploadMediaImageResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 97);

/**
 * 画像キャビネット台帳の 1 件
 *
 * @generated from message api_proto.v1.MediaImage
 */
export type MediaImage = Message<"api_proto.v1.MediaImage"> & {
  /**
   * ULID (Crockford base32、26 文字。作成順ソート可)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 公開 URL（一意）
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * R2 オブジェクトキー（media/uploads/{ulid}/{sanitized-filename}）
   *
   * @generated from field: string r2_key = 3;
   */
  r2Key: string;

  /**
   * 画像名（編集可能。初期値 = 元ファイル名から拡張子を除いたもの）
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * 変換後ベース画像の幅（px）。0 = 未計測（台帳導入前の移行分は未計測）
   *
   * @generated from field: int32 width = 7;
   */
  width: number;

  /**
   * 変換後ベース画像の高さ（px）。0 = 未計測（台帳導入前の移行分は未計測）
   *
   * @generated from field: int32 height = 8;
   */
  height: number;

  /**
   * 変換後ベース画像のMIME種別（例: image/webp）。空 = 未計測（台帳導入前の移行分は未計測）
   *
   * @generated from field: string content_type = 9;
   */
  contentType: string;

  /**
   * 変換後ベース画像のバイト数。0 = 未計測（台帳導入前の移行分は未計測）
   *
   * @generated from field: int64 byte_size = 10;
   */
  byteSize: bigint;
};

/**
 * Describes the message api_proto.v1.MediaImage.
 * Use `create(MediaImageSchema)` to create a new message.
 */
export const MediaImageSchema: GenMessage<MediaImage> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 98);

/**
 * ListMediaImages（新しい順 = id 降順）
 *
 * @generated from message api_proto.v1.ListMediaImagesRequest
 */
export type ListMediaImagesRequest = Message<"api_proto.v1.ListMediaImagesRequest"> & {
  /**
   * 1 始まり
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * デフォルト 20
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * 画像名の部分一致検索（空 = 絞り込みなし）
   *
   * @generated from field: string keyword = 3;
   */
  keyword: string;

  /**
   * true = どのエンティティの画像スロットからも参照されていない画像だけを返す。
   * 参照判定はURL完全一致。記事本文内の <img src> は最新リビジョンの本文走査による近似
   *
   * @generated from field: bool unused_only = 4;
   */
  unusedOnly: boolean;
};

/**
 * Describes the message api_proto.v1.ListMediaImagesRequest.
 * Use `create(ListMediaImagesRequestSchema)` to create a new message.
 */
export const ListMediaImagesRequestSchema: GenMessage<ListMediaImagesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 99);

/**
 * @generated from message api_proto.v1.ListMediaImagesResponse
 */
export type ListMediaImagesResponse = Message<"api_proto.v1.ListMediaImagesResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.MediaImage images = 1;
   */
  images: MediaImage[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message api_proto.v1.ListMediaImagesResponse.
 * Use `create(ListMediaImagesResponseSchema)` to create a new message.
 */
export const ListMediaImagesResponseSchema: GenMessage<ListMediaImagesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 100);

/**
 * UpdateMediaImageName（画像名のみ更新。存在しない id は NotFound）
 *
 * @generated from message api_proto.v1.UpdateMediaImageNameRequest
 */
export type UpdateMediaImageNameRequest = Message<"api_proto.v1.UpdateMediaImageNameRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message api_proto.v1.UpdateMediaImageNameRequest.
 * Use `create(UpdateMediaImageNameRequestSchema)` to create a new message.
 */
export const UpdateMediaImageNameRequestSchema: GenMessage<UpdateMediaImageNameRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 101);

/**
 * @generated from message api_proto.v1.UpdateMediaImageNameResponse
 */
export type UpdateMediaImageNameResponse = Message<"api_proto.v1.UpdateMediaImageNameResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaImage image = 1;
   */
  image?: MediaImage;
};

/**
 * Describes the message api_proto.v1.UpdateMediaImageNameResponse.
 * Use `create(UpdateMediaImageNameResponseSchema)` to create a new message.
 */
export const UpdateMediaImageNameResponseSchema: GenMessage<UpdateMediaImageNameResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 102);

/**
 * DeleteMediaImage（台帳レコードのみ削除。R2 実ファイルは消さないため既存参照は壊れない）
 *
 * @generated from message api_proto.v1.DeleteMediaImageRequest
 */
export type DeleteMediaImageRequest = Message<"api_proto.v1.DeleteMediaImageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api_proto.v1.DeleteMediaImageRequest.
 * Use `create(DeleteMediaImageRequestSchema)` to create a new message.
 */
export const DeleteMediaImageRequestSchema: GenMessage<DeleteMediaImageRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 103);

/**
 * @generated from message api_proto.v1.DeleteMediaImageResponse
 */
export type DeleteMediaImageResponse = Message<"api_proto.v1.DeleteMediaImageResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteMediaImageResponse.
 * Use `create(DeleteMediaImageResponseSchema)` to create a new message.
 */
export const DeleteMediaImageResponseSchema: GenMessage<DeleteMediaImageResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 104);

/**
 * GetMediaImage（台帳1件 + 使用箇所。存在しないidはNotFound）
 *
 * @generated from message api_proto.v1.GetMediaImageRequest
 */
export type GetMediaImageRequest = Message<"api_proto.v1.GetMediaImageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api_proto.v1.GetMediaImageRequest.
 * Use `create(GetMediaImageRequestSchema)` to create a new message.
 */
export const GetMediaImageRequestSchema: GenMessage<GetMediaImageRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 105);

/**
 * 画像の使用箇所1件（URL完全一致による逆引き結果）
 *
 * @generated from message api_proto.v1.MediaImageUsage
 */
export type MediaImageUsage = Message<"api_proto.v1.MediaImageUsage"> & {
  /**
   * roofer | author | interview | credential_item | craftsman | case_article | article
   *
   * @generated from field: string target_type = 1;
   */
  targetType: string;

  /**
   * roofer / credential_item / craftsman / case_articleは数値idの文字列、
   * author / interview / articleはslug
   *
   * @generated from field: string target_id = 2;
   */
  targetId: string;

  /**
   * 参照カラム名（logo_url / hero_image_url / message_sender_image_url / photo_url /
   * thumbnail_url / image_url / avatar_url / cover_url / og_image_url / body_html）
   *
   * @generated from field: string slot = 3;
   */
  slot: string;

  /**
   * 表示名（店名・タイトル等。レスポンスのみ）
   *
   * @generated from field: string label = 4;
   */
  label: string;
};

/**
 * Describes the message api_proto.v1.MediaImageUsage.
 * Use `create(MediaImageUsageSchema)` to create a new message.
 */
export const MediaImageUsageSchema: GenMessage<MediaImageUsage> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 106);

/**
 * @generated from message api_proto.v1.GetMediaImageResponse
 */
export type GetMediaImageResponse = Message<"api_proto.v1.GetMediaImageResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaImage image = 1;
   */
  image?: MediaImage;

  /**
   * @generated from field: repeated api_proto.v1.MediaImageUsage usages = 2;
   */
  usages: MediaImageUsage[];
};

/**
 * Describes the message api_proto.v1.GetMediaImageResponse.
 * Use `create(GetMediaImageResponseSchema)` to create a new message.
 */
export const GetMediaImageResponseSchema: GenMessage<GetMediaImageResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 107);

/**
 * ImportMediaImageFromUrl（外部URLから取得して台帳へ登録する取込経路）
 *
 * @generated from message api_proto.v1.ImportMediaImageFromUrlRequest
 */
export type ImportMediaImageFromUrlRequest = Message<"api_proto.v1.ImportMediaImageFromUrlRequest"> & {
  /**
   * 取得元URL。httpsのみ許可。サーバーがSSRFガード付きで取得し、
   * 10MB上限・Content-Typeがimage/* のもののみ受け付ける
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * 台帳の画像名（空 = ファイル名から拡張子を除いたもの）
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message api_proto.v1.ImportMediaImageFromUrlRequest.
 * Use `create(ImportMediaImageFromUrlRequestSchema)` to create a new message.
 */
export const ImportMediaImageFromUrlRequestSchema: GenMessage<ImportMediaImageFromUrlRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 108);

/**
 * @generated from message api_proto.v1.ImportMediaImageFromUrlResponse
 */
export type ImportMediaImageFromUrlResponse = Message<"api_proto.v1.ImportMediaImageFromUrlResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaImage image = 1;
   */
  image?: MediaImage;
};

/**
 * Describes the message api_proto.v1.ImportMediaImageFromUrlResponse.
 * Use `create(ImportMediaImageFromUrlResponseSchema)` to create a new message.
 */
export const ImportMediaImageFromUrlResponseSchema: GenMessage<ImportMediaImageFromUrlResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 109);

/**
 * CreateMediaImageUpload（署名付きPUT URLの発行。画像バイトをAPI本体に通さない取込経路の1段目）
 *
 * @generated from message api_proto.v1.CreateMediaImageUploadRequest
 */
export type CreateMediaImageUploadRequest = Message<"api_proto.v1.CreateMediaImageUploadRequest"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: int64 byte_size = 3;
   */
  byteSize: bigint;
};

/**
 * Describes the message api_proto.v1.CreateMediaImageUploadRequest.
 * Use `create(CreateMediaImageUploadRequestSchema)` to create a new message.
 */
export const CreateMediaImageUploadRequestSchema: GenMessage<CreateMediaImageUploadRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 110);

/**
 * 署名付きPUT URL（有効期限10分）をステージングキー
 * media/staging/{ulid}/{sanitized file name} に対して発行する。
 * クライアントはput_urlに同じContent-TypeヘッダでPUTする。
 * upload_idは不透明値（サーバーがステージングキーを復元できる）
 *
 * @generated from message api_proto.v1.CreateMediaImageUploadResponse
 */
export type CreateMediaImageUploadResponse = Message<"api_proto.v1.CreateMediaImageUploadResponse"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string put_url = 2;
   */
  putUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message api_proto.v1.CreateMediaImageUploadResponse.
 * Use `create(CreateMediaImageUploadResponseSchema)` to create a new message.
 */
export const CreateMediaImageUploadResponseSchema: GenMessage<CreateMediaImageUploadResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 111);

/**
 * FinalizeMediaImageUpload（取込経路の2段目。
 * ステージングを読み戻してUploadMediaImageと同じ検証・webp変換・バリアント生成・台帳登録を行い、
 * ステージングを削除する）
 *
 * @generated from message api_proto.v1.FinalizeMediaImageUploadRequest
 */
export type FinalizeMediaImageUploadRequest = Message<"api_proto.v1.FinalizeMediaImageUploadRequest"> & {
  /**
   * CreateMediaImageUploadが返した不透明値
   *
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * 台帳の画像名（空 = ファイル名から拡張子を除いたもの）
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message api_proto.v1.FinalizeMediaImageUploadRequest.
 * Use `create(FinalizeMediaImageUploadRequestSchema)` to create a new message.
 */
export const FinalizeMediaImageUploadRequestSchema: GenMessage<FinalizeMediaImageUploadRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 112);

/**
 * @generated from message api_proto.v1.FinalizeMediaImageUploadResponse
 */
export type FinalizeMediaImageUploadResponse = Message<"api_proto.v1.FinalizeMediaImageUploadResponse"> & {
  /**
   * @generated from field: api_proto.v1.MediaImage image = 1;
   */
  image?: MediaImage;
};

/**
 * Describes the message api_proto.v1.FinalizeMediaImageUploadResponse.
 * Use `create(FinalizeMediaImageUploadResponseSchema)` to create a new message.
 */
export const FinalizeMediaImageUploadResponseSchema: GenMessage<FinalizeMediaImageUploadResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 113);

/**
 * お問い合わせフォームからの送信 1 件
 *
 * @generated from message api_proto.v1.MediaContactSubmission
 */
export type MediaContactSubmission = Message<"api_proto.v1.MediaContactSubmission"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * お問い合わせ種別（フォームの inquiry_type 自由テキスト）
   *
   * @generated from field: string inquiry_type = 2;
   */
  inquiryType: string;

  /**
   * 送信者氏名
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 送信者メールアドレス
   *
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * 送信者電話番号（空可）
   *
   * @generated from field: string phone = 5;
   */
  phone: string;

  /**
   * 送信者住所（空可）
   *
   * @generated from field: string address = 6;
   */
  address: string;

  /**
   * 希望する対象店舗テキスト（自由入力。空 = 未入力）
   *
   * @generated from field: string target_company = 7;
   */
  targetCompany: string;

  /**
   * 本文
   *
   * @generated from field: string message = 8;
   */
  message: string;

  /**
   * 宛先の認定店 ID（0 = 宛先なし＝運営宛）
   *
   * @generated from field: int64 roofer_id = 9;
   */
  rooferId: bigint;

  /**
   * 送信時点の認定店名スナップショット（roofer_id = 0 の場合は空文字）
   *
   * @generated from field: string roofer_name = 10;
   */
  rooferName: string;

  /**
   * 対応済みかどうか
   *
   * @generated from field: bool is_handled = 11;
   */
  isHandled: boolean;

  /**
   * 送信日時
   *
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message api_proto.v1.MediaContactSubmission.
 * Use `create(MediaContactSubmissionSchema)` to create a new message.
 */
export const MediaContactSubmissionSchema: GenMessage<MediaContactSubmission> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 114);

/**
 * ListMediaContactSubmissions
 *
 * @generated from message api_proto.v1.ListMediaContactSubmissionsRequest
 */
export type ListMediaContactSubmissionsRequest = Message<"api_proto.v1.ListMediaContactSubmissionsRequest"> & {
  /**
   * 1 始まり
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * デフォルト 20
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * 認定店 ID で絞り込み（0 = 絞り込みなし、-1 = 宛先なし（運営宛）のみ）
   *
   * @generated from field: int64 roofer_id = 3;
   */
  rooferId: bigint;

  /**
   * 対応状況で絞り込み
   *
   * @generated from field: api_proto.v1.MediaContactHandledFilter handled_filter = 4;
   */
  handledFilter: MediaContactHandledFilter;
};

/**
 * Describes the message api_proto.v1.ListMediaContactSubmissionsRequest.
 * Use `create(ListMediaContactSubmissionsRequestSchema)` to create a new message.
 */
export const ListMediaContactSubmissionsRequestSchema: GenMessage<ListMediaContactSubmissionsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 115);

/**
 * @generated from message api_proto.v1.ListMediaContactSubmissionsResponse
 */
export type ListMediaContactSubmissionsResponse = Message<"api_proto.v1.ListMediaContactSubmissionsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.MediaContactSubmission items = 1;
   */
  items: MediaContactSubmission[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message api_proto.v1.ListMediaContactSubmissionsResponse.
 * Use `create(ListMediaContactSubmissionsResponseSchema)` to create a new message.
 */
export const ListMediaContactSubmissionsResponseSchema: GenMessage<ListMediaContactSubmissionsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 116);

/**
 * UpdateMediaContactSubmissionHandled
 *
 * @generated from message api_proto.v1.UpdateMediaContactSubmissionHandledRequest
 */
export type UpdateMediaContactSubmissionHandledRequest = Message<"api_proto.v1.UpdateMediaContactSubmissionHandledRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: bool is_handled = 2;
   */
  isHandled: boolean;
};

/**
 * Describes the message api_proto.v1.UpdateMediaContactSubmissionHandledRequest.
 * Use `create(UpdateMediaContactSubmissionHandledRequestSchema)` to create a new message.
 */
export const UpdateMediaContactSubmissionHandledRequestSchema: GenMessage<UpdateMediaContactSubmissionHandledRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 117);

/**
 * @generated from message api_proto.v1.UpdateMediaContactSubmissionHandledResponse
 */
export type UpdateMediaContactSubmissionHandledResponse = Message<"api_proto.v1.UpdateMediaContactSubmissionHandledResponse"> & {
  /**
   * 更新後のお問い合わせ
   *
   * @generated from field: api_proto.v1.MediaContactSubmission submission = 1;
   */
  submission?: MediaContactSubmission;
};

/**
 * Describes the message api_proto.v1.UpdateMediaContactSubmissionHandledResponse.
 * Use `create(UpdateMediaContactSubmissionHandledResponseSchema)` to create a new message.
 */
export const UpdateMediaContactSubmissionHandledResponseSchema: GenMessage<UpdateMediaContactSubmissionHandledResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_media_cms, 118);

/**
 * プレビュー対象の種別
 *
 * @generated from enum api_proto.v1.MediaPreviewTarget
 */
export enum MediaPreviewTarget {
  /**
   * @generated from enum value: MEDIA_PREVIEW_TARGET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 下書き revision
   *
   * @generated from enum value: MEDIA_PREVIEW_TARGET_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * 公開済み revision
   *
   * @generated from enum value: MEDIA_PREVIEW_TARGET_PUBLISHED = 2;
   */
  PUBLISHED = 2,
}

/**
 * Describes the enum api_proto.v1.MediaPreviewTarget.
 */
export const MediaPreviewTargetSchema: GenEnum<MediaPreviewTarget> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_media_cms, 0);

/**
 * プレビュー対象のコンテンツ種別
 *
 * @generated from enum api_proto.v1.MediaPreviewContentType
 */
export enum MediaPreviewContentType {
  /**
   * 未指定（後方互換: 記事として扱う）
   *
   * @generated from enum value: MEDIA_PREVIEW_CONTENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 記事（slug + target で revision を特定）
   *
   * @generated from enum value: MEDIA_PREVIEW_CONTENT_TYPE_ARTICLE = 1;
   */
  ARTICLE = 1,

  /**
   * 認定店（roofer_id で特定。公開状態に関わらず保存済みの内容を表示）
   *
   * インタビューは将来 3 を割り当てる想定（未実装）
   *
   * @generated from enum value: MEDIA_PREVIEW_CONTENT_TYPE_ROOFER = 2;
   */
  ROOFER = 2,
}

/**
 * Describes the enum api_proto.v1.MediaPreviewContentType.
 */
export const MediaPreviewContentTypeSchema: GenEnum<MediaPreviewContentType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_media_cms, 1);

/**
 * 資格・受賞歴・加盟団体マスターの種別
 *
 * @generated from enum api_proto.v1.MediaCredentialKind
 */
export enum MediaCredentialKind {
  /**
   * 未指定
   *
   * @generated from enum value: MEDIA_CREDENTIAL_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 資格
   *
   * @generated from enum value: MEDIA_CREDENTIAL_KIND_QUALIFICATION = 1;
   */
  QUALIFICATION = 1,

  /**
   * 受賞歴
   *
   * @generated from enum value: MEDIA_CREDENTIAL_KIND_AWARD = 2;
   */
  AWARD = 2,

  /**
   * 加盟団体
   *
   * @generated from enum value: MEDIA_CREDENTIAL_KIND_ASSOCIATION = 3;
   */
  ASSOCIATION = 3,

  /**
   * メーカー
   *
   * @generated from enum value: MEDIA_CREDENTIAL_KIND_MAKER = 4;
   */
  MAKER = 4,
}

/**
 * Describes the enum api_proto.v1.MediaCredentialKind.
 */
export const MediaCredentialKindSchema: GenEnum<MediaCredentialKind> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_media_cms, 2);

/**
 * 発信者画像の表示形。
 *
 * 縦横比からの自動判定では「横長ロゴ」と「横長写真」を区別できないことが実データで確認済みのため
 * （plus 600x402 = ロゴ / nitten 1600x739 = 写真）、入稿者が明示できる enum として持つ。
 * UNSPECIFIED は「未指定 = 自動判定」であって「circle」ではない（既存レコードの既定値）。
 *
 * @generated from enum api_proto.v1.MediaSenderImageFit
 */
export enum MediaSenderImageFit {
  /**
   * @generated from enum value: MEDIA_SENDER_IMAGE_FIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 正方形に切り抜いて丸表示（人物のバストアップ写真向け）
   *
   * @generated from enum value: MEDIA_SENDER_IMAGE_FIT_CIRCLE = 1;
   */
  CIRCLE = 1,

  /**
   * 切り抜かずに全体を収める（企業ロゴ向け）
   *
   * @generated from enum value: MEDIA_SENDER_IMAGE_FIT_CONTAIN = 2;
   */
  CONTAIN = 2,
}

/**
 * Describes the enum api_proto.v1.MediaSenderImageFit.
 */
export const MediaSenderImageFitSchema: GenEnum<MediaSenderImageFit> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_media_cms, 3);

/**
 * お問い合わせ対応状況絞り込みフィルター
 *
 * @generated from enum api_proto.v1.MediaContactHandledFilter
 */
export enum MediaContactHandledFilter {
  /**
   * 未指定（全件取得）
   *
   * @generated from enum value: MEDIA_CONTACT_HANDLED_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 未対応のみ
   *
   * @generated from enum value: MEDIA_CONTACT_HANDLED_FILTER_UNHANDLED = 1;
   */
  UNHANDLED = 1,

  /**
   * 対応済みのみ
   *
   * @generated from enum value: MEDIA_CONTACT_HANDLED_FILTER_HANDLED = 2;
   */
  HANDLED = 2,
}

/**
 * Describes the enum api_proto.v1.MediaContactHandledFilter.
 */
export const MediaContactHandledFilterSchema: GenEnum<MediaContactHandledFilter> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_media_cms, 4);

